"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Token = void 0;
const Common_1 = require("./Common");
const Base_1 = require("./Base");
const index_1 = require("../index");
class Token extends Base_1.Base {
    token = '';
    expires = null;
    key = '';
    path = '';
    email = '';
    contact = null;
    consumer_user_id = '';
    constructor(data, olMap) {
        super('_tokens', 10);
        (0, Common_1.setObjectProperties)(this, data, olMap, Token);
    }
}
exports.Token = Token;
index_1.olm._tokens = (ref, map) => {
    return new Token(ref, map);
};
